import EmailCard from './EmailCard';

const EmailCards = ({ emails, stats, period }) => {
  return emails.map((email) => {
    return <EmailCard key={email.id} email={email} stats={stats} period={period} />;
  });
};

export default EmailCards;
